import SectionTestimonials from './SectionTestimonials';

export default SectionTestimonials;
